<template>
  <div id="CredentialExchange" class="box">
    <div class="center" v-if="creds.loaded != true">
      <LoadingSpinner />
    </div>
    <div v-if="creds.loaded == true">
      <div id="Exchange">
        <div id="ExchangeIntro">
          <div id="ExchangeCount">
            <div
              id="exchange-countbox"
              v-bind:class="{ notickets: ticket_count == 0 }"
              :style="{ backgroundImage: `url(${cover1})` }"
            >
              <div id="exchange-ticket-count">{{ ticket_count }}</div>
              <div v-if="ticket_count > 0" id="exchange-ticket-label">
                Tickets
              </div>
              <div v-if="ticket_count == 0">
                <a
                  :href="ticket_url + '/#tickets'"
                  target="_blank"
                  id="exchange-ticket-label"
                  >+ Get Tickets</a
                >
              </div>
              <hr />
              <div v-if="lodging_count > 0">
                <span id="exchange-loding-count">{{ lodging_count }}</span>
                <span id="exchange-loding-label">Shambhalodging</span>
              </div>
              <div v-if="lodging_count == 0">
                <a
                  :href="ticket_url + '/#lodging'"
                  target="_blank"
                  id="exchange-loding-label"
                  >+ Get Shambhalodging</a
                >
              </div>
              <div v-if="addon_count > 0">
                <span id="exchange-addon-count">{{ addon_count }}</span>
                <span id="exchange-addon-label">Add-on</span>
              </div>
              <div v-if="addon_count == 0">
                <a
                  :href="ticket_url + '/#addons'"
                  target="_blank"
                  id="exchange-addon-label"
                  >+ Get Add-ons</a
                >
              </div>
            </div>
          </div>
          <div id="ExchangeNotice" v-if="transfer_mode != true">
            <h2 v-if="ticket_count >= 1">Congratulations!</h2>
            <h3 v-if="ticket_count > 1">
              You have your Ticket and {{ ticket_count - 1 }} extra ticket<span
                v-if="ticket_count > 2"
                >s</span
              >.
            </h3>
            <h3 v-if="ticket_count == 1">You have your Ticket!</h3>
            <h3 v-if="ticket_count < 1" class="error">
              You don't have any Tickets!<br />If you plan to attend you must
              <a :href="ticket_url + '/#tickets'" target="_blank" class="error"
                >PURCHASE</a
              >
              one.
            </h3>
            <h5 v-if="lodging_count > 0 || addon_count > 0">
              You also have
              <span v-if="lodging_count > 0"
                >{{ lodging_count }} Lodging Package<span
                  v-if="lodging_count > 1"
                  >s</span
                ></span
              ><span v-if="lodging_count > 0 && addon_count > 0"> and </span
              ><span v-if="addon_count > 0"
                >{{ addon_count }} Upgrade Add-on<span v-if="addon_count > 1"
                  >s</span
                ></span
              >.
            </h5>
            <div id="exchange-message">
              <div
                v-if="message_display != false && message_content != ''"
                v-bind:class="`msg msg-${message_display}`"
              >
                <strong>{{ message_display.capitalize() }}: </strong
                >{{ message_content }}
              </div>
            </div>
            <p>
              <strong
                >You can transfer Tickets, Lodging, or Add-ons to your friends
                below.</strong
              >
            </p>
            <p>
              The first-time volunteer deposit is not a ticket.
              The deposit order will be shown below in the orders section.
              You will be issued your crew access pass upon hire.
            </p>
            <p>
              <strong class="error">WARNING:</strong> Transferring an item
              cannot be undone! So please use extreme caution. Shambhala Music
              Festival is not responsible for any 3rd party transactions.
            </p>
            <p>
              <strong
                >No changes can be made to a Ticket, Lodging, or Add-on once
                it's been transferred.</strong
              >
            </p>
            <p>
              <strong
                >You cannot claim a Ticket, Lodging, or Add-on in a friends
                name.</strong
              >
            </p>
            <div class="button-row">
              <form>
                <button v-on:click="ReLoad">
                  <i class="fas fa-sync-alt"></i> ReLoad</button
                >
                <button v-if="!this.trans_allow" class="float-right" :disabled="!this.trans_allow">
                  Unclaim Above to Allow Xfer <i class="fas fa-sign-out-alt"></i>
                </button>
                <button v-else class="float-right" v-on:click="StartTransfer">
                  Start a Transfer <i class="fas fa-sign-out-alt"></i>
                </button>
              </form>
            </div>
          </div>
          <div id="ExchangeTransfer" v-if="transfer_mode == true">
            <h2>Transfer an Item</h2>
            <div
              v-if="message_display != false && message_content != ''"
              v-bind:class="`msg msg-${message_display}`"
            >
              <strong>{{ message_display.capitalize() }}: </strong
              >{{ message_content }}
            </div>
            <p>
              <strong>WARNING:</strong> Transfers cannot be undone, so please be
              certain before completing a transfer.
            </p>
            <p>
              The transfer will be sent to the email address specified so please
              double check that it is entered correctly.
            </p>
          </div>
        </div>
        <div id="CredentialsDetails" v-if="transfer_mode != true">
          <div v-if="ticket_count > 0">
            <h3>
              {{ ticket_count }} Ticket<span v-if="ticket_count > 1">s</span>
            </h3>
            <table id="creds-tickets" class="creds-table">
              <thead>
                <tr>
                  <th>Qty</th>
                  <th>Sku</th>
                  <th>Title</th>
                  <th>Transfer</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="ticket in tickets"
                  v-bind:id="ticket.id"
                  v-bind:key="ticket.id"
                  v-bind:class="getTransStatusClass(ticket)"
                  v-bind:tq="ticket_count"
                >
                  <td>1</td>
                  <td>{{ ticket.sku }}</td>
                  <td>{{ ticket.title }}</td>
                  <td class="trans-status">{{ getTransStatus(ticket) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="ticket_count == 0" class="error-background">
            <h3>
              <a :href="ticket_url + '/#tickets'" target="_blank" class="error"
                >Please Purchase a Ticket</a
              >
            </h3>
          </div>
          <div style="border-bottom: 1px solid var(--box-divider);"></div>
          <div v-if="lodging_count > 0">
            <h3>
              {{ lodging_count }} Lodging Package<span v-if="lodging_count > 1"
                >s</span
              >
            </h3>
            <table id="creds-lodging" class="creds-table">
              <thead>
                <tr>
                  <th>Qty</th>
                  <th>Sku</th>
                  <th>Title</th>
                  <th>Transfer</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="lodge in lodging"
                  v-bind:id="lodge.id"
                  v-bind:key="lodge.id"
                  v-bind:class="getTransStatusClass(lodge)"
                  v-bind:tq="lodging_count"
                >
                  <td>1</td>
                  <td>{{ lodge.sku }}</td>
                  <td>{{ lodge.title }}</td>
                  <td class="trans-status">{{ getTransStatus(lodge) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="addon_count > 0">
            <h3>
              {{ addon_count }} Upgrade Add-on<span v-if="addon_count > 1"
                >s</span
              >
            </h3>
            <table id="creds-addon" class="creds-table">
              <thead>
                <tr>
                  <th>Qty</th>
                  <th>Sku</th>
                  <th>Title</th>
                  <th>Transfer</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ao in addon" v-bind:key="ao.id">
                  <td>1</td>
                  <td>{{ ao.sku }}</td>
                  <td>{{ ao.title }}</td>
                  <td>{{ getTransStatus(ao) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="donation_count > 0">
            <h3>
              {{ donation_count }} Donation<span v-if="donation_count > 1"
                >s</span
              >
            </h3>
            <table id="creds-donations" class="creds-table">
              <thead>
                <tr>
                  <th>Qty</th>
                  <th>Sku</th>
                  <th>Title</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="donation in donations"
                  v-bind:id="donation.id"
                  v-bind:key="donation.id"
                  v-bind:tq="donation_count"
                >
                  <td>1</td>
                  <td>{{ donation.sku }}</td>
                  <td>{{ donation.title }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div id="CredentialTransfer" v-if="transfer_mode == true">
          <form id="transferto">
            <div>
              <h4>Transfer To</h4>
              <div class="row">
                <div class="block">
                  <label
                    ><i class="fas fa-user"></i> First Name (legal)
                    <span class="required">*</span></label
                  >
                  <input
                    id="trans_firstname"
                    name="first_name"
                    type="text"
                    v-model="trans_firstname"
                    v-on:focus="ClearMessages"
                    v-on:change="CheckIfMeetsRequirements"
                    v-on:keyup="CheckIfMeetsRequirements"
                    placeholder="First name (legal)"
                    required="required"
                  />
                  <label v-show="invalidFirstnameFormat" class="errorLabel"><i class="fas fa-exclamation-triangle"></i> Unfortunately at this time we can only accept characters from the ISO basic Latin alphabet and some special characters.</label>
                </div>
                <div class="block">
                  <label
                    ><i class="fas fa-user"></i> Last name (legal)
                    <span class="required">*</span></label
                  >
                  <input
                    id="trans_lastname"
                    name="last_name"
                    type="text"
                    v-model="trans_lastname"
                    v-on:focus="ClearMessages"
                    v-on:change="CheckIfMeetsRequirements"
                    v-on:keyup="CheckIfMeetsRequirements"
                    placeholder="Last name (legal)"
                  />
                  <label v-show="invalidLastnameFormat" class="errorLabel"><i class="fas fa-exclamation-triangle"></i> Unfortunately at this time we can only accept characters from the ISO basic Latin alphabet and some special characters.</label>
                </div>
              </div>
              <div class="row">
                <div class="block">
                  <label
                    ><i class="fas fa-envelope"></i> Email Address
                    <span class="required">*</span></label
                  >
                  <input
                    id="trans_email"
                    name="email"
                    type="email"
                    v-model="trans_email"
                    v-on:focus="ClearMessages"
                    v-on:change="CheckIfMeetsRequirements"
                    v-on:keyup="CheckIfMeetsRequirements"
                    placeholder="Email Address"
                    required="required"
                  />
                  <label v-show="invalidEmailFormat" class="errorLabel"><i class="fas fa-exclamation-triangle"></i> Invalid Email Address</label>
                </div>
                <div class="block">
                  <label
                  ><i class="fas fa-envelope"></i> Confirm Email Address
                    <span class="required">*</span></label
                  >
                  <input
                      id="trans_email_confirm"
                      name="email"
                      type="email"
                      v-on:focus="ClearMessages"
                      v-on:change="CheckIfMeetsRequirements"
                      v-on:keyup="CheckIfMeetsRequirements"
                      placeholder="Confirm Email Address"
                      required="required"
                  />
                  <label v-show="invalidConfirmFormat" class="errorLabel"><i class="fas fa-exclamation-triangle"></i> Emails do not match</label>
                </div>
              </div>
              <div class="row">
                <div class="block">
                  <label><i class="fas fa-phone"></i> Phone</label>
                  <input
										id="trans_phone"
                    name="phone"
                    type="phone"
                    v-model="trans_phone"
                    v-on:focus="ClearMessages"
                    v-on:change="CheckIfMeetsRequirements"
                    v-on:keyup="CheckIfMeetsRequirements"
                    placeholder="Phone Number"
                  />
                  <label v-show="invalidPhoneFormat" class="errorLabel"><i class="fas fa-exclamation-triangle"></i> Invalid Phone Number</label>
                </div>
              </div>
            </div>
            <div class="mt-2">
              <h4>Transfer Items</h4>
              <table id="creds-transfer" class="creds-table">
                <thead>
                  <tr>
                    <th>Qty</th>
                    <th>Sku</th>
                    <th>Title</th>
                    <th>Remaining</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="cred in transcreds"
                    v-bind:key="cred.sku"
                    v-bind:id="cred.sku"
                    v-bind:data-id="cred.sku"
                    v-bind:data-sku="cred.sku"
                    v-bind:data-title="cred.title"
                    v-bind:data-qty="cred.qty"
                    v-bind:data-available="cred.available"
                    v-bind:data-remaining="cred.remaining"
                  >
                    <td class="trans-qty">
                      <input
                        v-bind:data-for="cred.sku"
                        v-bind:id="String().random(15)"
                        type="number"
                        min="0"
                        v-bind:max="cred.available"
                        value="0"
                        onchange="window.portal.creds.updateReview(this);"
                        onclick="this.onchange();"
                        onkeyup="this.onchange();"
                      />
                    </td>
                    <td class="trans-sku">{{ cred.sku }}</td>
                    <td class="trans-title">{{ cred.title }}</td>
                    <td class="trans-remaining">{{ cred.remaining }}</td>
                  </tr>
                </tbody>
              </table>
              <div style="text-align: center; font-size: 12px">
                (Any item you've selected for your own use and welcome pass
                can't be transferred. If you intend to transfer one of those
                items, please deselect it from your own use on your welcome pass
                above and it will become available.)
              </div>
            </div>
            <div class="mt-2">
              <h4 v-if="trans_qty > 0">Review Transfer</h4>
              <table id="creds-review" class="creds-table">
                <thead>
                  <tr v-if="trans_qty > 0">
                    <th>Qty</th>
                    <!-- <th>Sku</th> -->
                    <th>Title</th>
                    <th></th>
                    <th>Name</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="cred in transcreds"
                    v-bind:key="cred.sku"
                    v-bind:id="`TRANS_${cred.sku}`"
                    v-bind:data-id="cred.sku"
                    v-bind:data-sku="cred.sku"
                    v-bind:data-title="cred.title"
                    v-bind:data-qty="cred.qty"
                    v-bind:data-available="cred.available"
                    v-bind:data-remaining="cred.remaining"
                    class="hide"
                  >
                    <td class="rev-qty" v-bind:id="`TRANSQTY_${cred.sku}`">
                      {{ cred.qty }}
                    </td>
                    <td class="rev-title">{{ cred.title }}</td>
                    <td class="rev-to">
                      <i class="fas fa-arrow-alt-right"></i>
                    </td>
                    <td class="rev-name">
                      {{ trans_firstname ? trans_firstname : "N/A" }}
                      {{ trans_lastname }}
                    </td>
                    <td class="rev-email">
                      {{ trans_email ? trans_email : "N/A" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="button-row" v-if="!trans_confirm">
              <button class="button-no" v-on:click="CancelTransfer">
                <i class="fas fa-times"></i> Cancel
              </button>
              <button
                class="float-right"
                v-on:click="StartConfirm"
                v-bind:disabled="!meets_requirements"
              >
                Make Transfer
              </button>
            </div>
            <div v-bind:class="{ hide: meets_requirements }">
              <h6 class="center fill-in">
                <strong class="error"
                  ><span class="required">*</span> Note:</strong
                >
                &nbsp;<a
                  href="#transferto"
                  onclick="window.portal.app.$SmoothScroll(document.getElementById('transferto'), 200, function() { window.scrollBy({ top: -50, left: 0, behavior: 'smooth' }); }); return false;"
                  >please enter all the required fields above
                  <i class="fas fa-arrow-alt-up"></i></a
                >.
              </h6>
            </div>
            <div class="msg-error" id="transfer-confirm" v-if="trans_confirm">
              <form>
                <h4>PLEASE CONFIRM</h4>
	              <br/>
	              <h5>Transfer to: <span style="color:black;">{{ this.trans_email}}</span></h5>
                <p>
                  <strong
                    >PLEASE read the following carefully and confirm:</strong
                  >
                </p>
                <p v-bind:class="{ 'msg-success': trans_agree }">
                  <input
                    id="trans_agree"
                    name="trans_agree"
                    checked="false"
                    type="checkbox"
                    v-model="trans_agree"
                    v-on:change="CheckConfirm"
                  />
                  You agree that transferring these items will remove them from
                  your account and it cannot be undone and have verified that
                  all the items listed in the Review Transfer section are
                  correct.
                </p>
                <p v-bind:class="{ 'msg-success': trans_agree2 }">
                  <input
                    id="trans_agree2"
                    name="trans_agree2"
                    checked="false"
                    type="checkbox"
                    v-model="trans_agree2"
                    v-on:change="CheckConfirm"
                  />
                  You agree that Shambhala Music Festival is not responsible for
                  items transferred in error or any 3rd party transactions.
                </p>
                <p>
                  <strong
                    >PLEASE make sure you aren't transferring away your own
                    Ticket or Lodging if you plan on attending.</strong
                  >
                </p>
                <div class="button-row">
                  <button class="button-no" v-on:click="CancelConfirm">
                    <i class="fas fa-times"></i> No
                  </button>
                  <button
                    class="float-right button-yes"
                    v-bind:disabled="trans_confirmed != 1"
                    v-on:click="MakeTransfer"
                  >
                    <i class="fas fa-check"></i> Yes
                  </button>
                </div>
              </form>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner.vue";
import isEmail from 'validator/lib/isEmail';

export default {
  name: "CredentialExchange",
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      user: window.portal.user,
      creds: window.portal.creds,
      credentials: window.portal.creds.credentials,
      transfer_mode: false,
      message_display: false,
      message_content: "",
      trans_firstname: "",
      trans_lastname: "",
      trans_email: "",
      trans_phone: "",
      trans_qty: 0,
      trans_confirm: false,
      trans_agree: false,
      trans_agree2: false,
      trans_agree3: false,
      trans_confirmed: false,
      meets_requirements: false,
      ticket_url: window.portal.ticket_url,
      cover1: window.portal.cover1 ? window.portal.cover1 : process.env.VUE_APP_COVER_IMAGE_1,
      invalidFirstnameFormat: false,
      invalidLastnameFormat: false,
      invalidEmailFormat: false,
      invalidConfirmFormat: false,
      invalidPhoneFormat: false,
    };
  },
  computed: {
    transfers: function () {
      return window.portal.creds.transfers;
    },
    ticket_count: function () {
      let { Ticket: tickets = 0 } = window.portal.creds.credentials.reduce(
        function (obj, v) {
          obj[v.type] = (obj[v.type] || 0) + 1;
          return obj;
        },
        {}
      );
      return tickets;
    },
    tickets: function () {
      let tickets = window.portal.creds.credentials.filter(function (cred) {
        return cred.type === "Ticket";
      });
      return tickets;
    },
    lodging_count: function () {
      let { Lodging: lodging = 0 } = window.portal.creds.credentials.reduce(
        function (obj, v) {
          obj[v.type] = (obj[v.type] || 0) + 1;
          return obj;
        },
        {}
      );
      return lodging;
    },
    donation_count: function () {
      let { Donation: donation = 0 } = window.portal.creds.credentials.reduce(
        function (obj, v) {
          obj[v.type] = (obj[v.type] || 0) + 1;
          return obj;
        },
        {}
      );
      return donation;
    },
    lodging: function () {
      let lodging = window.portal.creds.credentials.filter(function (cred) {
        return cred.type === "Lodging";
      });
      return lodging;
    },
    donations: function () {
      let donations = window.portal.creds.credentials.filter(function (cred) {
        return cred.type === "Donation";
      });
      return donations;
    },
    addon_count: function () {
      let { AddOn: addon = 0 } = window.portal.creds.credentials.reduce(
        function (obj, v) {
          obj[v.type] = (obj[v.type] || 0) + 1;
          return obj;
        },
        {}
      );
      return addon;
    },
    addon: function () {
      let addon = window.portal.creds.credentials.filter(function (cred) {
        return cred.type === "AddOn";
      });
      return addon;
    },
    transcreds: function () {
      let transferables = window.portal.creds.credentials.filter(function (
        cred
      ) {
        return cred.authed != 1 && cred.transferable == 1;
      });
      let trans_counts = transferables.reduce(function (obj, v) {
        obj[v.sku] = (obj[v.sku] || 0) + 1;
        return obj;
      }, {});
      let transcreds = transferables.reduce(function (obj, v) {
        if (!("key" in obj)) {
          obj[v.sku] = {
            sku: v.sku,
            title: v.title,
            qty: 0,
            remaining: trans_counts[v.sku],
            available: trans_counts[v.sku],
          };
        }
        return obj;
      }, {});
      return transcreds;
    },
    trans_allow: function () {
      return (Object.keys( this.transcreds ).length > 0);
    },
  },
  mounted: function () {
    window.portal.creds.updateReview = this.adjustTransfers;
    window.portal.creds.startTransfer = this.StartTransfer;
    window.portal.creds.cancelTransfer = this.CancelTransfer;
    window.portal.creds.stopTransfer = this.stopTransfer;
    window.portal.creds.reload = this.Load;
    this.Load();
  },
  methods: {
    Clear() {
      window.portal.clearCreds();
    },
    ReLoadButton(e) {
      if (e) {
        e.preventDefault();
      }
      this.ReLoad();
    },
    ReLoad() {
      window.portal.app.$SmoothScroll(
        document.getElementById("CredentialExchange"),
        200,
        function () {
          window.scrollBy({ top: -50, left: 0, behavior: "smooth" });
        }
      );
      this.Load();
    },
    Load() {
      window.portal.creds.loaded = false;
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.session.token;
      axios
        .post(`${window.portal.api_server}/userportal/credentials`, {
          confirm: window.portal.user.id.decode().encode(),
        })
        .then((res) => {
          if (res.data.status.success) {
            window.portal.creds.credentials = res.data.data;
            window.portal.creds.loaded = true;
            window.debug(res.data.data);
            window.debug("USER CREDS LOADED");
            if (window.portal.creds.transfer_message != "") {
              this.DisplaySuccessMessage(window.portal.creds.transfer_message);
              window.portal.creds.transfer_message = "";
            }
            window.portal.messages.reload();
            window.portal.welcome.reload();
          } else {
            window.portal.creds.loaded = true;
            window.debug(res.data.data);
            window.debug("USER CREDS NOT FOUND");
          }
        })
        .catch((err) => {
          window.portal.creds.loaded = false;
          window.debug("USER CREDS FAILURE");
          window.debug(err);
          window.portal.logout();
        });
    },
    ClearTransfer() {
      this.trans_firstname = "";
      this.trans_lastname = "";
      this.trans_email = "";
      this.trans_phone = "";
      this.trans_qty = 0;
      this.trans_agree = false;
      this.trans_agree2 = false;
      this.trans_agree3 = false;
      this.trans_confirm = false;
      this.reviewloaded = false;
    },
    StartTransfer(e) {
      if (e) {
        e.preventDefault();
      }
      this.ClearMessages();
      this.ReLoad();
      this.ClearTransfer();
      this.transfer_mode = true;
    },
    CancelTransfer(e) {
      if (e) {
        e.preventDefault();
      }
      this.ClearMessages();
      this.ReLoad();
      this.ClearTransfer();
      this.transfer_mode = false;
    },
    StopTransfer() {
      this.ClearTransfer();
      this.transfer_mode = false;
    },
    DisplayErrorMessage(msg) {
      this.message_content = msg;
      this.message_display = "error";
      window.portal.app.$SmoothScroll(
        document.getElementById("CredentialExchange"),
        300
      );
    },
    DisplaySuccessMessage(msg) {
      this.message_content = msg;
      this.message_display = "success";
      this.ReLoad();
      window.portal.app.$SmoothScroll(
        document.getElementById("CredentialExchange"),
        300
      );
    },
    ClearMessages() {
      this.message_display = false;
      this.message_content = "";
    },
    getTransStatus(obj) {
      let transferable = "";
      if (obj.transferable && !obj.authed) {
        transferable = "Available";
      } else {
        transferable = obj.authed_to;
      }
      return transferable;
    },
    getTransStatusClass(obj) {
      let newclass = "";
      if (obj.transferable && !obj.authed) {
        newclass = "cred-available";
      } else if (obj.transferable && !obj.transfer) {
        newclass = "cred-transfered";
      } else {
        newclass = "cred-selected";
      }
      return newclass;
    },
    adjustTransfers(obj) {
      let parent = document.getElementById(obj.dataset.for);
      let remaining = parent.querySelector(".trans-remaining");
      let max = Number(document.getElementById(obj.id).getAttribute("max"));
      obj.value = isNaN(obj.value) || obj.value == "" ? 0 : Number(obj.value);
      if (obj.value > max) {
        obj.value = max;
      }
      parent.dataset.qty = obj.value;
      document.getElementById(`TRANSQTY_${parent.dataset.sku}`).innerHTML =
        parent.dataset.qty;
      if (parent.dataset.qty > 0) {
        document
          .getElementById(`TRANS_${parent.dataset.sku}`)
          .classList.remove("hide");
      } else {
        document
          .getElementById(`TRANS_${parent.dataset.sku}`)
          .classList.add("hide");
      }
      parent.dataset.remaining = parent.dataset.available - parent.dataset.qty;
      remaining.innerHTML = parent.dataset.remaining;
      if (parent.dataset.remaining > 0) {
        remaining.classList.remove("error");
      } else {
        remaining.classList.add("error");
      }
      window.portal.creds.transfer[parent.dataset.sku] = {
        sku: parent.dataset.sku,
        title: parent.dataset.title,
        qty: parent.dataset.qty,
      };
      let filterd_list = [];
      this.trans_qty = 0;
      for (let key in window.portal.creds.transfer) {
        if (window.portal.creds.transfer[key].qty > 0) {
          filterd_list[key] = {
            sku: window.portal.creds.transfer[key].sku,
            title: window.portal.creds.transfer[key].title,
            qty: window.portal.creds.transfer[key].qty,
          };
          this.trans_qty += window.portal.creds.transfer[key].qty;
        }
      }
      window.portal.creds.transfer = filterd_list;
      this.CheckIfMeetsRequirements();
    },
    StartConfirm(e) {
      if (e) {
        e.preventDefault();
      }
      this.trans_confirm = true;
      this.trans_agree = false;
      this.trans_agree2 = false;
      this.trans_agree3 = false;
      this.trans_confirmed = false;
    },
    CancelConfirm(e) {
      if (e) {
        e.preventDefault();
      }
      this.trans_confirm = false;
      this.trans_confirmed = false;
    },
    CheckConfirm() {
      if (this.trans_agree && this.trans_agree2) {
        this.trans_confirmed = true;
        document
          .getElementById("transfer-confirm")
          .classList.remove("msg-error");
        document
          .getElementById("transfer-confirm")
          .classList.add("msg-success");
      } else {
        this.trans_confirmed = false;
        document
          .getElementById("transfer-confirm")
          .classList.remove("msg-success");
        document.getElementById("transfer-confirm").classList.add("msg-error");
      }
    },
    MakeTransfer(e) {
      if (e) {
        e.preventDefault();
      }
			if (!confirm('Transfer to:\n\n'+this.trans_email)) {
				return false;
	    }
      window.portal.creds.loaded = false;
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.session.token;
      axios
        .post(`${window.portal.api_server}/userportal/transfer`, {
          confirm: window.portal.user.id.decode().encode(),
          sendto: JSON.stringify({
            first_name: this.trans_firstname,
            last_name: this.trans_lastname,
            email: this.trans_email,
            phone: this.trans_phone,
          }).encode(),
          sendwhat: JSON.stringify(
            window.helpers.deepClone(window.portal.creds.transfer)
          ).encode(), //first_name: this.first_name,
        })
        .then((res) => {
          if (res.data.status.success) {
            // Hack to get proper update when going from 1 ticket to 0
            alert(`Successful Transfer to ${this.trans_firstname} ${this.trans_lastname} at ${this.trans_email}.`);
            location.reload();

            // Legacy code below
            window.debug("TRANSFER SUCCESS");
            this.DisplaySuccessMessage(
              `Successful Transfer to ${this.trans_firstname} ${this.trans_lastname} at ${this.trans_email}.`
            );
            window.portal.creds.transfer_message = `Successful Transfer to ${this.trans_firstname} ${this.trans_lastname} at ${this.trans_email}.`;
            this.ReLoad();
            this.ClearTransfer();
            this.transfer_mode = false;
          } else {
            window.debug("TRANSFER ISSUE");
            this.DisplayErrorMessage("Transfer Unsuccessful.");
            window.portal.creds.loaded = true;
          }
        })
        .catch((err) => {
          window.debug("TRANSFER FAILURE");
          this.DisplayErrorMessage("Transfer Failure.");
          window.debug(err);
          window.portal.user.loaded = false;
          alert('Please check below to make sure the transfer was successful.')
          location.reload();
          //window.portal.logout();
        });
    },
    CheckIfMeetsRequirements() {
      const trans_email_el = document.getElementById("trans_email")
      const trans_email_confirm_el = document.getElementById("trans_email_confirm")
      const trans_firstname_el = document.getElementById("trans_firstname")
      const trans_lastname_el = document.getElementById("trans_lastname")
      const trans_phone_el = document.getElementById("trans_phone")

      if (
          this.trans_qty < 1 ||
          !(trans_email_el.value === trans_email_confirm_el.value) ||
          !this.isValidName(trans_firstname_el.value) ||
          !this.isValidName(trans_lastname_el.value) ||
          !this.isValidEmail(trans_email_el.value)
      ) {
        this.meets_requirements = false
      } else {
        this.meets_requirements = true
      }

      //Validate Email
      const hasEmailValue = trans_email_el.value.length > 0;
      const isEmailValid = this.isValidEmail(trans_email_el.value);

      trans_email_el.classList.toggle("error", hasEmailValue && !isEmailValid);
      this.invalidEmailFormat = hasEmailValue && !isEmailValid;

      // Confirm Email matches
      const hasConfirmEmailValue = trans_email_confirm_el.value;
      const doEmailsMatch = trans_email_el.value === trans_email_confirm_el.value;

      trans_email_confirm_el.classList.toggle("error", hasConfirmEmailValue && !doEmailsMatch);
      this.invalidConfirmFormat = hasConfirmEmailValue && !doEmailsMatch;

      //Validate First Name
      const hasFirstNameValue = trans_firstname_el.value.length > 0;
      const isFirstNameValid = this.isValidName(trans_firstname_el.value);

      trans_firstname_el.classList.toggle("error", hasFirstNameValue && !isFirstNameValid);
      this.invalidFirstnameFormat = hasFirstNameValue && !isFirstNameValid;

      //Validate Last Name
      const hasLastNameValue = trans_lastname_el.value.length > 0;
      const isLastNameValid = this.isValidName(trans_lastname_el.value);

      trans_lastname_el.classList.toggle("error", hasLastNameValue && !isLastNameValid);
      this.invalidLastnameFormat = hasLastNameValue && !isLastNameValid;

      //Validate Phone Name
      const hasPhoneValue = trans_phone_el.value.length > 0;
      const isPhoneValid = this.isValidPhone(trans_phone_el.value);

      trans_phone_el.classList.toggle("error", hasPhoneValue && !isPhoneValid);
      this.invalidPhoneFormat = hasPhoneValue && !isPhoneValid;
		},
    isValidName(name) {
      // eslint-disable-next-line no-useless-escape
      //ISO basic Latin alphabet whitespace and some special characters
      const nameRegex = /^[a-zA-Z-',.\s!#$%&_*()]+$/;
      return nameRegex.test(name)
    },
    isValidEmail(email) {
      // eslint-disable-next-line no-useless-escape
      //Email must meets standard format
      return isEmail(email)
    },
    isValidPhone(phone) {
      // eslint-disable-next-line no-useless-escape
      //Digits, whitespace, + and parenthesis are allowed
      const phonePattern = /^[\d\s\(\)\-+]{10,}$/;
      return phonePattern.test(phone)
    },
	},
};
</script>

<style>
/* #### Exchange #### */
#Exchange {
  display: block;
  position: relative;
  box-sizing: border-box;
  text-align: left;
}

/* #### Exchange Intro #### */
#ExchangeIntro {
  display: flex;
}

/* #### Exchange Count Box #### */
#ExchangeCount {
  display: inline-block;
  width: 200px;
  text-align: center;
  vertical-align: top;
  font-family: "Oswald", Tahoma, Verdana, sans-serif;
}
#exchange-countbox {
  width: 200px;
  background: var(--box-dark-background) url("/images/smf_lightblue_icon.svg")
    top center no-repeat;
  background-size: contain;
  box-sizing: border-box;
  text-align: center;
  margin: 0 auto 20px;
  color: var(--box-dark-text-color);
  padding-bottom: 10px;
  position: sticky;
  top: calc(var(--header-height) + 10px);
}
#exchange-ticket-count {
  font-size: 75px;
  line-height: 1.6;
  font-weight: bold;
  padding: 10px 0 0;
  margin: 0 0 -25px;
  color: var(--box-dark-header-color);
}
#exchange-ticket-label {
  font-size: 25px;
  margin: -2px 15px -5px;
}
#exchange-countbox hr {
  margin: 5px 10px;
}
#exchange-loding-count {
  font-weight: bold;
  margin: 0 10px 0 0;
  color: var(--box-dark-header-color);
}
#exchange-addon-count {
  font-weight: bold;
  margin: 0 10px 0 0;
  color: var(--box-dark-header-color);
}
#ExchangeCount a {
  color: var(--box-dark-link-color);
  text-decoration: none;
}
#ExchangeCount a:hover {
  color: var(--box-dark-link-color-hover);
}
/* ## No Tickets ## */
#exchange-countbox.notickets {
  background: #900 url("/images/smf_lightred_icon.svg") top center no-repeat;
}
@media only screen and (max-width: 800px) {
  #ExchangeIntro {
    display: block;
  }
  #ExchangeCount {
    display: block;
    width: auto;
  }
}

/* #### Exchange Notice #### */
#ExchangeNotice {
  display: inline-block;
  width: calc(100% - 200px);
  text-align: left;
  vertical-align: top;
  padding: 0 15px 20px 20px;
}
@media only screen and (max-width: 800px) {
  #ExchangeNotice {
    display: block;
    width: auto;
  }
}
.fill-in {
  font-size: 15px;
}

/* #### Exchange Transfer #### */
#ExchangeTransfer {
  display: inline-block;
  width: calc(100% - 200px);
  text-align: left;
  vertical-align: top;
  padding: 0 15px 20px 20px;
}
#ExchangeTransfer form .row {
  padding: 5px 10px;
}
@media only screen and (max-width: 800px) {
  #ExchangeTransfer {
    display: block;
    width: auto;
  }
  #creds-transfer th:nth-child(2) {
    display: none;
  }
  #creds-transfer td:nth-child(2) {
    display: none;
  }
  #creds-review th:nth-child(5) {
    display: none;
  }
  #creds-review td:nth-child(5) {
    display: none;
  }
}

/* #### Credentials Details #### */
#CredentialsDetails {
}
#CredentialsDetails > div {
  border: 0 none;
}
#CredentialsDetails h3 {
  text-transform: uppercase;
  text-align: center;
  font-size: 24px;
  padding: 15px;
  margin: 0;
}
.creds-table {
  width: 100%;
  font-size: 13px;
  border: 0px none;
  border-spacing: 0px;
  border-collapse: collapse;
}
.creds-table th {
  margin: 0;
  padding: 5px 10px;
  text-align: center;
  border: 0px none;
  background: var(--button-background);
  color: var(--button-text-color);
  position: sticky;
  top: var(--header-height);
}
.creds-table td {
  margin: 5px;
  padding: 5px 10px;
  text-align: center;
  border: 0px none;
  height:3.75em;
}
.creds-table tr {
  border-bottom: 1px solid var(--box-divider);
}
.creds-table tr:nth-child(even) {
  #background: #eee;
}
.creds-table tr:nth-child(odd) {
  #background: #fefefe;
}
.creds-table tr:last-child {
  border-bottom: 0px none;
}
.creds-table tr:hover {
  background: #F1F3F5;
  #color: var(--button-text-color);
}
.creds-table tr.cred-transfered {
  background: #41b883;
  color: var(--button-text-color);
}
.creds-table tr.cred-transfered td.trans-status {
  color: transparent;
  font-size: 0px;
}
#creds-tickets tr.cred-transfered td.trans-status:after {
  content: "Your Ticket";
  font-size: 13px;
  color: #fff;
}
#creds-lodging tr.cred-transfered td.trans-status:after {
  content: "Your Lodging";
  font-size: 13px;
  color: #fff;
}

#CredentialTransfer form .row {
  padding: 5px 10px;
}
#creds-transfer .trans-remaining {
  color: var(--button-background);
  font-size: 30px;
  font-weight: bold;
  font-family: "Oswald", Tahoma, Verdana, sans-serif;
  padding-top: 14px !important;
}
#creds-review .rev-title {
  text-align: left;
  padding-left: 20px;
  padding-right: 10px;
}
#creds-review .rev-to {
  color: var(--button-background);
  font-size: 30px;
}
#creds-review .rev-qty {
  color: var(--button-background);
  font-size: 30px;
  font-weight: bold;
  font-family: "Oswald", Tahoma, Verdana, sans-serif;
  padding-top: 14px !important;
}
#creds-review tr:nth-child(even),
#creds-review tr:nth-child(odd) {
  background: #eee;
}
#creds-review tr:nth-child(even):hover,
#creds-review tr:nth-child(odd):hover {
  background: #999;
}
#transfer-confirm {
  box-sizing: border-box;
  padding: 20px;
}
#transfer-confirm button {
  padding-left: 15px;
  padding-right: 15px;
}
#transfer-confirm i {
  margin-right: 10px;
}
#transfer-confirm.msg-error {
  color: #900 !important;
  border: 1px solid #900;
}
#transfer-confirm.msg-success {
  color: #090 !important;
  border: 1px solid #090;
}
.errorLabel {
	color: #900;
	font-size: small;
}
.mt-2 {
	margin-top: 2em;
}
#CredentialTransfer .creds-table td {
	height: 2.5em;
}
</style>
